import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import modifierGroupsSaga from './sagas';
import reducer from './reducer';

export function ModifierGroups({ children }) {
  useInjectSaga({ key: 'modifierGroups', saga: modifierGroupsSaga });
  useInjectReducer({ key: 'modifierGroups', reducer });

  return React.Children.only(children);
}

ModifierGroups.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withModifierGroups } from './withModifierGroups';
export default compose(withConnect, memo)(ModifierGroups);
